import { combineReducers } from "redux";
import tourReducer from "./tourReducer";
import tourSealNumberReducer from "./tourSealNumberReducer";
import riderReducer from "./riderReducer";
import homebaseReducer from "./homebaseReducer";
import teamReducer from "./teamReducer";
import loaderReducer from "./loaderReducer";

const reducers = combineReducers({
  loader: loaderReducer,
  tours: tourReducer,
  tourSealNumber: tourSealNumberReducer,
  riders: riderReducer,
  homebase: homebaseReducer,
  team: teamReducer
});

export default reducers;
